module.exports = __webpack_public_path__ + "img/slide2-6.6b669b37.png";